"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdobeSignConfigOutSerializer = void 0;
exports.AdobeSignConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=adobeSignConfigOut.js.map